import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../api/client";

/** Approve or reject a post; invalidates the post + list queries so the UI updates. */
export function useApproval(postId: string) {
  const qc = useQueryClient();

  const approve = useMutation({
    mutationFn: (body: { notes?: string; publish_to_instagram?: boolean }) =>
      api.posts.approve(postId, body),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ["post", postId] });
      void qc.invalidateQueries({ queryKey: ["posts"] });
    },
  });

  const reject = useMutation({
    mutationFn: (body: { notes?: string }) => api.posts.reject(postId, body),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ["post", postId] });
      void qc.invalidateQueries({ queryKey: ["posts"] });
    },
  });

  const patch = useMutation({
    mutationFn: (body: {
      caption_feed?: string;
      hashtags?: string[];
      source?: string;
    }) => api.posts.patch(postId, body),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ["post", postId] });
      void qc.invalidateQueries({ queryKey: ["posts"] });
    },
  });

  return { approve, reject, patch };
}
